<template>
  <div class="app-wrapper">
    <sidebar />
    <div class="main-wrapper">
      <navbar />
      <app-main />
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import AppMain from './components/AppMain'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.app-wrapper {
  width: 100vw;
  height: 100vh;
  flex-basis: 0;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  //background-image: url("");
  background-size: 100% 100%;
  // background-color: rgb(192, 206, 218);
}
.main-wrapper {
  height: 100vh;
  flex: 1;
  flex-basis: 0;
  overflow: hidden;
  background-color: #eaf4fe;
  display: flex;
  flex-direction: column;
}
</style>
